export default {
	_id: {
		show_name: "_id",
		name: "_id",
		type: "Field_mongoid",
		default: "",
	},
	product_color: {
		show_name: "SPU",
		name: "product_color",
		type: "Field_relate_simple_id",
		default: {
			_id: null,
			name: "",
		},
		name_fields: ["name"],
		table_name: "app_product_color",
		model_name: "Product_color",
	},
	item: {
		show_name: "SKU",
		name: "item",
		type: "Field_relate_simple_id",
		default: {
			_id: null,
			name: "",
		},
		name_fields: ["name"],
		table_name: "app_item",
		model_name: "Item",
	},
	updated_at: {
		show_name: "更新时间",
		name: "updated_at",
		type: "Field_ts",
		default: 0,
		show_type: "ts",
	},
	created_user: {
		show_name: "创建人",
		name: "created_user",
		type: "Field_adminuser",
		default: {
			_id: null,
			name: "",
		},
		name_fields: ["name"],
		table_name: "admin_user",
		model_name: "Adminuser",
	},
	created_at: {
		show_name: "创建时间",
		name: "created_at",
		type: "Field_ts",
		default: 0,
		show_type: "ts",
	},
	deleted_at: {
		show_name: "时间",
		name: "deleted_at",
		type: "Field_ts",
		default: 0,
		show_type: "ts",
	},
	name: {
		show_name: "名称",
		name: "name",
		type: "Field_string",
		default: "",
	},
	color_code: {
		show_name: "色号",
		name: "color_code",
		type: "Field_string",
		default: "",
	},
	color_name: {
		show_name: "颜色",
		name: "color_name",
		type: "Field_string",
		default: "",
	},
	show_id: {
		show_name: "货号-色号",
		name: "show_id",
		type: "Field_string",
		default: "",
	},
	brand_show_id: {
		show_name: "品牌特定编号",
		name: "brand_show_id",
		type: "Field_string",
		default: "",
	},
	brand: {
		show_name: "品牌",
		name: "brand",
		type: "Field_relate_simple_id",
		default: {
			_id: null,
			name: "",
		},
		name_fields: ["name"],
		table_name: "app_brand",
		model_name: "Brand",
	},
	classify: {
		show_name: "分类",
		name: "classify",
		type: "Field_classify_id",
		default: [],
		name_fields: ["name"],
		table_name: "app_classify",
		model_name: "Classify",
	},
	color: {
		show_name: "颜色",
		name: "color",
		type: "Field_relate_simple_id",
		default: {
			_id: null,
			name: "",
		},
		name_fields: ["name"],
		table_name: "app_color",
		model_name: "Color",
	},
	model: {
		show_name: "尺码",
		name: "model",
		type: "Field_relate_simple_id",
		default: {
			_id: null,
			name: "",
		},
		name_fields: ["name"],
		table_name: "app_model",
		model_name: "Model",
	},
	amount: {
		show_name: "库存",
		name: "amount",
		type: "Field_int",
		default: 0,
	},
	storehouse: {
		show_name: "预留仓",
		name: "storehouse",
		type: "Field_relate_simple_id",
		default: {
			_id: null,
			name: "",
		},
		name_fields: ["name"],
		table_name: "app_reserve_storehouse",
		model_name: "Reserve_storehouse",
	},
	num:{
		show_name: "退减数量",
		name: "num",
		type: "Field_int",
		default: 0,
	},
	warehouse: {
		show_name: "退至仓库",
		name: "warehouse",
		type: "Field_relate_simple_id",
		default: {
			_id: null,
			name: "",
		},
		name_fields: ["name"],
		table_name: "app_warehouse",
		model_name: "Warehouse",
	},
};
